import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatDate } from "../../lib/api";

export const BlogCard = ({ blog, index = 0 }) => (
  <Link
    to={`/blogs/${blog.slug}`}
    data-testid={`blog-card-${blog.slug}`}
    className="group flex flex-col h-full border-t border-ink/20 pt-6"
  >
    <div className="relative overflow-hidden rounded-2xl aspect-[4/3] bg-paper-2">
      {blog.cover_image ? (
        <img src={blog.cover_image} alt={blog.title} loading="lazy" className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-[transform,filter] duration-700" />
      ) : (
        <div className="w-full h-full grid place-items-center font-serif-i text-6xl text-ink/30">§</div>
      )}
      <span className="absolute top-4 left-4 rounded-full bg-paper/90 backdrop-blur px-3 py-1 font-mono-x text-[11px] uppercase tracking-wider text-ink">{blog.category}</span>
    </div>
    <div className="flex items-center justify-between mt-5 font-mono-x text-xs text-ink/65">
      <span>{String(index + 1).padStart(2, "0")} — {formatDate(blog.created_at)}</span>
      <span>{blog.read_time || 3} min read</span>
    </div>
    <h3 className="mt-3 font-display font-bold text-xl sm:text-2xl leading-tight tracking-tight group-hover:text-[var(--brass-deep)] transition-colors duration-300">{blog.title}</h3>
    <p className="mt-3 text-sm text-ink/70 leading-relaxed line-clamp-3">{blog.excerpt}</p>
    <span className="mt-auto pt-5 inline-flex items-center gap-1.5 text-sm font-semibold">
      Read article <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
    </span>
  </Link>
);
